<template>
  <div class="login-page" dir="rtl">
    <van-icon name="arrow-left" class="back-icon" @click="goBack" />
    <h1>تسجيل</h1>
    <form @submit.prevent="register" class="rtl-form">
      <van-field
        v-model="email"
        label="البريد الإلكتروني:"
        placeholder="أدخل البريد الإلكتروني"
        required
        :label-align="'right'"
        input-align="right"
        dir="ltr"
      />
      <van-field
        v-model="password"
        type="password"
        label="كلمة المرور:"
        placeholder="أدخل كلمة المرور"
        required
        :label-align="'right'"
        input-align="right"
        dir="rtl"
      />
      <van-field
        v-model="confirmPassword"
        type="password"
        label="تأكيد كلمة المرور:"
        placeholder="أعد إدخال كلمة المرور"
        required
        :label-align="'right'"
        input-align="right"
        dir="rtl"
      />
      <van-field
        v-model="currency"
        label="العملة:"
        placeholder="اختر العملة"
        readonly
        :label-align="'right'"
        input-align="right"
        @click="showCurrencySheet = true"
        required
      />
      <van-action-sheet
        v-model="showCurrencySheet"
        :actions="currencyOptions"
        cancel-text="إلغاء"
        description="يرجى اختيار عملة"
        close-on-click-action
        @select="onSelectCurrency"
        @cancel="onCancel"
      />
      <van-button type="primary" native-type="submit" block>تسجيل</van-button>
    </form>
    <p class="register-link">
      <a @click="goToLogin">العودة إلى تسجيل الدخول</a>
    </p>
  </div>
</template>

<script>
import { Button, Field, ActionSheet, Toast, Icon } from "vant";
import { defineComponent } from "vue";
import { registerUser } from "@/api/api.js";

export default defineComponent({
  name: "UserLogin",
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [ActionSheet.name]: ActionSheet,
    [Icon.name]: Icon,
  },
  data() {
    return {
      email: "",
      password: "",
      confirmPassword: "",
      currency: "USD",
      showCurrencySheet: false,
      currencyOptions: [
        {
          name: "دولار أمريكي",
          value: "USD",
        },
        { name: "يوان صيني", value: "CNY" },
        {
          name: "درهم إماراتي",
          value: "AED",
        },
        { name: "دينار بحريني", value: "BHD" },
        { name: "جنيه مصري", value: "EGP" },
        { name: "دينار أردني", value: "JOD" },
        { name: "دينار كويتي", value: "KWD" },
        { name: "ليرة لبنانية", value: "LBP" },
        { name: "ريال قطري", value: "QAR" },
        { name: "ريال سعودي", value: "SAR" },
      ],
    };
  },
  methods: {
    async register() {
      if (this.password !== this.confirmPassword) {
        Toast.fail("كلمتا المرور غير متطابقتين");
        return;
      }
      try {
        const data = await registerUser({
          email: this.email,
          password: this.password,
          currency: this.currency,
        });
        if (data.code === "failed") {
          Toast.fail(data.message);
        } else {
          this.$router.push("/login");
          Toast.success("تم التسجيل بنجاح");
        }
      } catch (error) {
        console.error("Error:", error);
        Toast.fail("حدث خطأ أثناء التسجيل");
      }
    },
    onSelectCurrency(option) {
      this.currency = option.value;
      this.showCurrencySheet = false;
    },
    goToLogin() {
      this.$router.push("/login");
    },
    onCancel() {
      this.showCurrencySheet = false;
    },
    goBack() {
      this.$router.replace("/");
    },
  },
});
</script>

<style scoped>
.login-page {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  font-family: "Arial", sans-serif;
}

.rtl-form {
  text-align: right;
}

.login-page h1 {
  text-align: center;
  margin-bottom: 30px;
  font-size: 24px;
  color: #333;
}

:deep(.van-field__label) {
  color: #333;
  font-weight: 600;
}

:deep(.van-button--primary) {
  margin-top: 20px;
  height: 44px;
  font-size: 16px;
  background-color: #2c3e50;
  border-color: #2c3e50;
}

:deep(.van-button--primary:active) {
  background-color: #1a2633;
  border-color: #1a2633;
}

.register-link {
  text-align: center;
  margin-top: 20px;
}

.register-link a {
  color: #2c3e50;
  text-decoration: none;
  font-weight: 600;
}

.register-link a:hover {
  color: #1a2633;
}

:deep(.van-action-sheet__description) {
  text-align: right;
}

:deep(.van-action-sheet__item) {
  text-align: right;
}

.back-icon {
  position: absolute;
  top: 20px;
  right: 10px;
  cursor: pointer;
  z-index: 100;
  transform: rotate(180deg);
}
</style>
